import { Brand, Link } from '@farol-ds/react'
import classNames from 'classnames'

import styles from './auth-topbar.module.scss'

interface AuthTopbarProps {
  className?: string
}

export function AuthTopbar({ className }: AuthTopbarProps) {
  return (
    <div className={classNames(styles.topbarContainer, className)}>
      <div className={styles.content}>
        <Link
          href="https://www.jusbrasil.com.br"
          aria-label="Voltar para página principal Jusbrasil"
        >
          <Brand width={194} />
        </Link>
      </div>
    </div>
  )
}
